import { FilterScopeProvider, ResetAllFiltersButton, useTeamFilterOptions } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { teamIdAtom } from '@/atoms/team/team';
import { TeamFilterTabs } from '@/components/team/filters/TeamFilterTabs';
import { useComparisonFilterTabsActive } from '@/hooks/useComparisonFilterTabsActive';
import { LayoutWithFilters } from '../LayoutWithFilters';

const TeamLayoutWithFiltersContent = ({
  children,
  settingsPanel,
  insightComponent,
}: {
  children: ReactNode;
  settingsPanel?: ReactNode;
  insightComponent?: ReactNode;
}) => {
  const { t } = useTranslation(['general']);
  const tabsActive = useComparisonFilterTabsActive();
  useTeamFilterOptions(useAtomValue(teamIdAtom));
  return (
    <LayoutWithFilters
      settingsPanel={settingsPanel}
      insightComponent={insightComponent}
      filters={<TeamFilterTabs />}
      filtersTitle={t('filters.other', { ns: 'general' })}
      filtersActions={tabsActive ? undefined : <ResetAllFiltersButton />}
    >
      {children}
    </LayoutWithFilters>
  );
};

export const TeamLayoutWithFilters = (props: {
  children: ReactNode;
  settingsPanel?: ReactNode;
  insightComponent?: ReactNode;
}) => (
  <FilterScopeProvider scope="main">
    <TeamLayoutWithFiltersContent {...props} />
  </FilterScopeProvider>
);
